// src/pages/PaymentSuccess.jsx
// Shown after successful Razorpay or Stripe payment
// Route: /success

import { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function PaymentSuccess() {
  const { user, markAsPaid } = useAuth();
  const navigate = useNavigate();
  const [done,  setDone ] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    async function activate() {
      try {
        if (!user) { navigate('/login'); return; }
        await markAsPaid();
        setDone(true);
        // Auto redirect to dashboard after 4 seconds
        setTimeout(() => navigate('/dashboard'), 4000);
      } catch (err) {
        setError('Something went wrong activating your account. Please contact support.');
      }
    }
    activate();
  }, [user]);

  if (error) {
    return (
      <div style={{ minHeight: '100vh', backgroundColor: '#0a0a0a', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
        <div style={{ textAlign: 'center', maxWidth: 400 }}>
          <div style={{ fontSize: 40, marginBottom: 16 }}>⚠️</div>
          <div style={{ fontSize: 18, fontWeight: 600, color: '#fff', marginBottom: 8 }}>Activation issue</div>
          <p style={{ fontSize: 13, color: '#6b7280', marginBottom: 24, lineHeight: 1.6 }}>{error}</p>
          <a href="mailto:info@thetradeclass.com" style={{ padding: '10px 24px', borderRadius: 10, backgroundColor: '#10b981', color: '#fff', textDecoration: 'none', fontSize: 14, fontWeight: 600 }}>
            Contact support →
          </a>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#0a0a0a', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ textAlign: 'center', maxWidth: 420 }}>
        {!done ? (
          <>
            <div style={{ fontSize: 40, marginBottom: 16 }}>⏳</div>
            <div style={{ fontSize: 18, fontWeight: 600, color: '#fff', marginBottom: 8 }}>Activating your account…</div>
            <p style={{ fontSize: 13, color: '#6b7280' }}>Just a moment while we unlock your full access.</p>
          </>
        ) : (
          <>
            <div style={{ fontSize: 32, marginBottom: 16, letterSpacing: 8 }}>🎉🚀📈</div>
            <h1 style={{ fontSize: 24, fontWeight: 700, color: '#fff', marginBottom: 8 }}>You're in!</h1>
            <p style={{ fontSize: 14, color: '#6b7280', marginBottom: 28, lineHeight: 1.7 }}>
              Full access unlocked. All 59 lessons, tools, and everything else is now yours — forever.
            </p>

            <div style={{ backgroundColor: 'rgba(16,185,129,0.06)', border: '1px solid rgba(16,185,129,0.2)', borderRadius: 14, padding: '18px 20px', marginBottom: 24, textAlign: 'left' }}>
              {[
                'Modules 04–10 unlocked (43 lessons)',
                'All chart patterns and indicator lessons',
                'Risk management and psychology modules',
                'Certificate of completion',
                'Lifetime access + future updates',
              ].map((item, i) => (
                <div key={i} style={{ display: 'flex', gap: 8, fontSize: 13, color: '#9ca3af', marginBottom: i === 4 ? 0 : 8 }}>
                  <span style={{ color: '#10b981', flexShrink: 0 }}>✓</span>{item}
                </div>
              ))}
            </div>

            <p style={{ fontSize: 12, color: '#4b5563', marginBottom: 20 }}>
              Redirecting to your dashboard in a few seconds…
            </p>

            <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link to="/dashboard" style={{ padding: '11px 24px', borderRadius: 10, backgroundColor: '#10b981', color: '#fff', textDecoration: 'none', fontSize: 14, fontWeight: 600 }}>
                Go to dashboard →
              </Link>
              <Link to="/learn/04/01" style={{ padding: '11px 20px', borderRadius: 10, border: '1px solid rgba(255,255,255,0.12)', color: '#9ca3af', textDecoration: 'none', fontSize: 14 }}>
                Start Module 4
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}